<ul class="nav nav-tabs" role="tablist">
    <ng-container *ngIf="!isEdit">
      <li class="nav-item">
        <a class="nav-link" [ngClass]="{'active': nameMenu === 'information_general'}"
          routerLink="/{{branchofficeSlug}}/turismo/tours/nuevo">
          <span class="d-none d-md-block">Información general</span><span class="d-block d-md-none"><i
              class="mdi mdi-home-variant h5"></i></span>
        </a>
      </li>
    </ng-container>
    <ng-container *ngIf="isEdit">
      <li class="nav-item">
        <a class="nav-link" [ngClass]="{'active': nameMenu === 'information_general'}"
          routerLink="/{{branchofficeSlug}}/turismo/tours/editar/{{checkId}}">
          <span class="d-none d-md-block">Información general</span><span class="d-block d-md-none"><i
              class="mdi mdi-home-variant h5"></i></span>
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link" [ngClass]="{'active': nameMenu === 'gallery_image'}"
          routerLink="/{{branchofficeSlug}}/turismo/tours/imagenes/{{checkId}}">
          <span class="d-none d-md-block">Galería fotos</span><span class="d-block d-md-none"><i
              class="mdi mdi-account h5"></i></span>
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link" [ngClass]="{'active': nameMenu === 'gallery_video'}"
          routerLink="/{{branchofficeSlug}}/turismo/tours/videos/{{checkId}}">
          <span class="d-none d-md-block">Galería iframe videos</span><span class="d-block d-md-none"><i
              class="mdi mdi-email h5"></i></span>
        </a>
      </li>
    </ng-container>
  </ul>
  